/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\OfferTableUser\OfferTableUser.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Wednesday October 9th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday October 9th 2024 3:43:03 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useEffect, useMemo, useState } from "react";
import { OfferUserType } from "Types/offer.type";
import { OfferRowUser } from "../OfferRowUserSingle/OfferRowUser";
import { TablePaper } from "Content/Table/TablePaper";
import OfferService from "Services/Offer/OfferService";

type OfferTableProps = {
    Status?: string,
};

export default function OfferTable(props: OfferTableProps) {
    const [offers, setOffers] = useState<OfferUserType[]>([]);

    useEffect(() => {
        OfferService.getMyOffers({status: props.Status}).then((result: {data: OfferUserType[]}) => {
            setOffers(result.data);
        }).catch((error) => {
            console.log(error);
        });
    }, []);

    const offerKeysOffer = ["Date", "Vehicle", "Quantity", "RentalCost", "Mileage", "Month", "File", "Status"];

    const buildRows = (offers: OfferUserType[]) => {
        const offerToDisplay = [];
        for (let i = 0; i < offers.length; ++i)
            offerToDisplay.push(<OfferRowUser key={Math.random()} Offer={offers[i]} />);
        return offerToDisplay;
    };

    const offerValues = useMemo(() => {
        return buildRows(offers);
    }, [offers]);

    return (
        <TablePaper items={offerValues} headerList={offerKeysOffer} isCollapsable />
    );
};
